const EARTH_RADIUS_KM = 6371;

const degreesToRadians = (value: number) => value * Math.PI / 180;

/**
 * Distance in KM between Earth Coordinates
 * https://stackoverflow.com/a/365853
 * @param {number} lat1
 * @param {number} lon1
 * @param {number} lat2
 * @param {number} lon2
 */
export const inKmBetweenEarthCoordinates = (lat1, lon1, lat2, lon2) => {
  const dLat = degreesToRadians(lat2 - lat1);
  const dLon = degreesToRadians(lon2 - lon1);
  const latA = degreesToRadians(lat1);
  const latB = degreesToRadians(lat2);
  const a
    = Math.sin(dLat / 2) * Math.sin(dLat / 2)
    + Math.sin(dLon / 2) * Math.sin(dLon / 2)
    * Math.cos(latA) * Math.cos(latB)
  ;
  return EARTH_RADIUS_KM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export default {
  inKmBetweenEarthCoordinates,
};
